import { Component } from '@angular/core';

@Component({
  selector: 'my-portal-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'new-portal';
}
